import { LogradouroCep } from './logradouro-cep.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class LogradouroCepService {

    constructor(private http: Http){
    }

    getLogradouroCeps(): Observable<LogradouroCep[]> {
        return this.http.get(`${NTECH_API}/logradouro-cep`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }
}


// WEBPACK FOOTER //
// ./src/app/logradouro-cep/logradouro-cep.service.ts